
import { fromTime, fromFormatDate } from '../functions/Utilities';

const EmergencyShutdown = (props) => {  

return (  
        <div className="notice"> 
            <div className="notice_body" id="share">
                <div className="notice_type planned_type">DATE: {fromTime(props.notice.notice_time).toUpperCase()}</div>
                <div className="notice_subject planned">PLANNED URGENT<br/> REPAIRS</div> 
                <div className="notice_planned_time">  
                    <span>DATE:</span> {fromFormatDate(props.notice.notice_shutdown).toUpperCase()}
                </div> 
                <div className="notice_planned_time">  
                    <span>START TIME:</span> {props.notice.notice_start} – <span>END TIME:</span> {props.notice.notice_end}
                </div>  
                <div className="notice_affected_planned"> 
                    <div className="row">
                    {props.notice.streets.map((street, key) => { 
                        return(
                            <div className="col-sm-6" key={key}>{street}</div> 
                        )})}
                    </div> 
                </div>
                <div className="note_planned"> 
                <div dangerouslySetInnerHTML={{__html:  props.notice.notice_text }} /> 
                </div> 
            </div> 
        </div>  
    );
}

export default EmergencyShutdown;

